var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElmartLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3779_1589)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.018 6.244v5.582l2.237-.009 2.234-.014.014-.98.01-.984-1.264-.01-1.268-.013V2.624H9.172l.015 1.24.009 1.244h1.987V.661H.018v5.583zM5.583 25.059h5.583l-.01-2.238-.014-2.233-.979-.015-.984-.009-.01 1.263-.014 1.268H1.964V15.904l1.24-.014 1.244-.01v-1.987H0V25.06h5.583zM13.273 2.894l.014 2.238.98.014.984.01.01-1.264.013-1.268h7.192v7.192l-1.24.014-1.244.01v1.986l2.224-.009 2.223-.014.01-5.573.014-5.569H13.264l.01 2.233zM22.165 13.89l-2.238.015-.014.98-.01.983 1.264.01 1.267.014V23.083H15.243l-.014-1.24-.01-1.243h-1.987l.01 2.223.014 2.224 5.573.01 5.569.014V13.88l-2.233.01zM9.078 9.745l-3.123 3.117 3.132 3.132 3.132 3.132 3.132-3.132 3.132-3.132-3.118-3.117c-1.712-1.718-3.127-3.118-3.141-3.118-.014 0-1.429 1.405-3.146 3.118zm4.967 1.324l1.798 1.798-1.812 1.812-1.807 1.807-1.807-1.807-1.812-1.812 1.797-1.798c.99-.989 1.808-1.798 1.822-1.798.014 0 .832.81 1.821 1.798z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.563 4.223h4.326v4.326H3.563zM3.562 21.513v-4.326h4.326v4.326zM16.795 4.223h4.326v4.326h-4.326zM20.836 17.412v4.326H16.51v-4.326z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3779_1589"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .66)",
    d: "M0 0h24.454v24.41H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElmartLogo);
export default __webpack_public_path__ + "static/media/elmartLogo.dba9b70037b58a66fc20faac783b5f38.svg";
export { ForwardRef as ReactComponent };